<template>
    <div class="renderPage animate-fade-in reporte-container">
        <!-- Header Section -->
        <v-toolbar color="primary" dark flat class="mb-4 rounded-xl">
            <v-icon class="mr-2" size="24">mdi-history</v-icon>
            <v-toolbar-title class="text-subtitle-1 text-sm-h5 font-weight-black px-0 text-uppercase">
                Histórico Premios
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon color="white" to="/home" class="glass-btn">
                <v-icon>mdi-close</v-icon>
            </v-btn>
        </v-toolbar>

        <v-container fluid class="pa-0">
            <v-row>
                <!-- Filters Area -->
                <v-col cols="12" class="mb-2">
                    <v-card class="glass-card rounded-xl pa-4 elevation-2">
                        <v-form ref="form" v-model="valid">
                            <v-row align="center">
                                <!-- Periodo -->
                                <v-col cols="12" sm="8" md="8" class="py-1">
                                    <v-dialog ref="dialog" v-model="dateModal" :return-value.sync="dates" persistent width="290px">
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-text-field v-model="dates" label="Periodo" prepend-inner-icon="mdi-calendar" readonly required
                                                :rules="dateRules" v-bind="attrs" v-on="on" outlined dense rounded hide-details></v-text-field>
                                        </template>
                                        <v-date-picker v-model="dates" range color="primary">
                                            <v-spacer></v-spacer>
                                            <v-btn text color="primary" @click="dateModal = false">Cancel</v-btn>
                                            <v-btn text color="primary" @click="$refs.dialog.save(dates)">OK</v-btn>
                                        </v-date-picker>
                                    </v-dialog>
                                </v-col>

                                <!-- Generar Botón -->
                                <v-col cols="12" sm="4" md="4" class="py-1 d-flex align-center">
                                    <v-btn color="primary" class="rounded-pill font-weight-bold" elevation="2" @click="getReport()" :disabled="!valid" height="40" block>
                                        <v-icon left>mdi-file-document-outline</v-icon>
                                        Generar
                                    </v-btn>
                                </v-col>
                            </v-row>
                        </v-form>
                    </v-card>
                </v-col>

                <!-- Data Table Area -->
                <v-col cols="12" v-if="validInfo">
                    <v-card class="rounded-xl overflow-hidden glass-card elevation-2">
                        <v-data-table 
                            :headers="headers" 
                            :items="items"
                            class="premium-table"
                            mobile-breakpoint="0"
                        >
                            <template v-slot:[`item.montoVendido`]="{ item }">
                                <span class="primary--text font-weight-bold">₡{{ item.montoVendido }}</span>
                            </template>
                            <template v-slot:[`item.numeroGanador`]="{ item }">
                                <span class="font-weight-black text-h6">{{ item.numeroGanador }}</span>
                            </template>
                            <template v-slot:[`item.montoPerdido`]="{ item }">
                                <span class="error--text font-weight-bold">₡{{ item.montoPerdido }}</span>
                            </template>

                            <template v-slot:[`item.actions`]="{ item }">
                                <v-btn color="primary" icon small class="elevation-1" @click.stop="editItem(item)">
                                    <v-icon small>mdi-eye</v-icon>
                                </v-btn>
                            </template>
                        </v-data-table>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>

        <!-- Information Modal -->
        <v-dialog v-model="dialogInformacionAdicional" max-width="800px" content-class="rounded-xl theme-aware-dialog">
            <v-card class="glass-card rounded-xl overflow-hidden theme-aware-card">
                <v-toolbar color="primary" dark flat class="px-2">
                    <v-icon class="mr-2" size="24">mdi-trophy-variant</v-icon>
                    <v-toolbar-title class="text-subtitle-1 text-sm-h6 font-weight-black px-0 text-uppercase">
                        Tiquetes Ganadores
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon color="white" @click="cancelarInformacionAdicional" class="glass-btn">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>

                <v-card-text class="pt-4 px-2 px-sm-6">
                    <v-container fluid class="pa-0">
                        <v-row>
                            <!-- Dashboard Summary Cards -->
                            <v-col cols="12" v-if="validInfo">
                                <v-row>
                                    <v-col cols="12" sm="4">
                                        <v-card class="glass-card rounded-xl pa-3 text-center elevation-2 d-flex flex-column align-center justify-center h-100">
                                            <span class="text-caption text-uppercase font-weight-bold grey--text text--darken-1 mb-1">Sorteo</span>
                                            <span class="text-subtitle-1 font-weight-black primary--text">{{ nombreSorteo.replace('Sorteo: ', '') }}</span>
                                        </v-card>
                                    </v-col>
                                    <v-col cols="12" sm="4">
                                        <v-card class="glass-card rounded-xl pa-3 text-center elevation-2 d-flex flex-column align-center justify-center h-100">
                                            <span class="text-caption text-uppercase font-weight-bold grey--text text--darken-1 mb-1">Fecha</span>
                                            <span class="text-subtitle-1 font-weight-black">{{ fecha.replace('Fecha: ', '') }}</span>
                                        </v-card>
                                    </v-col>
                                    <v-col cols="12" sm="4">
                                        <v-card class="glass-card rounded-xl pa-3 text-center elevation-2 d-flex flex-column align-center justify-center h-100">
                                            <span class="text-caption text-uppercase font-weight-bold grey--text text--darken-1 mb-1"># Ganador</span>
                                            <span class="text-h5 font-weight-black error--text">{{ numeroGanador.replace('# Ganador: ', '') }}</span>
                                        </v-card>
                                    </v-col>
                                </v-row>
                            </v-col>

                            <!-- Winning Tickets Table -->
                            <v-col cols="12">
                                <v-card class="rounded-xl overflow-hidden glass-card elevation-2 mt-2">
                                    <v-data-table 
                                        :headers="headers2" 
                                        :items="items2"
                                        class="premium-table"
                                        mobile-breakpoint="0"
                                    >
                                        <template v-slot:[`item.monto`]="{ item }">
                                            <span class="font-weight-medium">₡{{ item.monto }}</span>
                                        </template>
                                        <template v-slot:[`item.premio`]="{ item }">
                                            <span class="success--text font-weight-black">₡{{ item.premio }}</span>
                                        </template>
                                        <template v-slot:[`item.canjeadoString`]="{ item }">
                                            <v-chip 
                                                :color="item.canjeadoString === 'Sí' || item.canjeadoString === 'Si' ? 'success' : 'warning'" 
                                                small 
                                                class="font-weight-bold" 
                                                text-color="white"
                                            >
                                                {{ item.canjeadoString === 'Sí' || item.canjeadoString === 'Si' ? 'CANJEADO' : 'PENDIENTE' }}
                                            </v-chip>
                                        </template>
                                    </v-data-table>
                                </v-card>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>

                <v-card-actions class="pa-4 bg-transparent border-top">
                    <v-spacer></v-spacer>
                    <v-btn color="primary" class="rounded-pill font-weight-bold px-6" elevation="2" @click="cancelarInformacionAdicional">
                        Aceptar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";

export default {
    components: {},
    data() {
        return {
            valid: false,
            validDecargar: false,
            validInfo: false,
            dateModal: false,
            dialogInformacionAdicional: false,
            dates: [],
            items: [],
            items2: [],
            nombreSorteo: '?',
            fecha: '?',
            numeroGanador: '?',
            dateRules: [
                (v) => v.length == 2 || "Fecha Inicial y Fecha Final Requeridas",
            ],
            headers: [
                {
                    text: "Sorteo",
                    align: "start",
                    value: "sorteoNombre",
                },
                {
                    text: "Fecha",
                    align: "start",
                    value: "fechaString",
                },
                {
                    text: "Venta Total",
                    align: "start",
                    value: "montoVendido",
                },
                {
                    text: "# Ganador",
                    align: "start",
                    value: "numeroGanador",
                },
                {
                    text: "Total Premios",
                    align: "start",
                    value: "montoPerdido",
                },
                { text: "Ver Premios", value: "actions", width: 50, sortable: false },
            ],
            headers2: [
                {
                    text: "# Tiquete",
                    align: "start",
                    value: "idTiquete",
                },
                {
                    text: "Jugador",
                    align: "start",
                    value: "nombreCliente",
                },
                {
                    text: "Monto",
                    align: "start",
                    value: "monto",
                },
                {
                    text: "Premio",
                    align: "start",
                    value: "premio",
                },
                {
                    text: "Canjeado",
                    align: "start",
                    value: "canjeadoString",
                },
                {
                    text: "Fecha de canje",
                    align: "start",
                    value: "fechaCanjeString",
                },
            ],
            reporte: {
                fechaInicio: new Date().toLocaleString("en-US", { timeZone: "America/Costa_Rica" }),
                fechaFin: new Date().toLocaleString("en-US", { timeZone: "America/Costa_Rica" }),
            },
        };
    },

    computed: {
        ...mapGetters(["user", "strCia"]),
    },

    created() {
    },

    methods: {
        getReport() {
            this.getReportePremios();
            //this.getRecibidos();
        },

        editItem(item) {
            this.snackValue = false;
            this.editedIndex = this.items.indexOf(item);
            this.editedItem = Object.assign({}, item);
            this.getReportePremiosByDate();
            this.mostrarInformacionAdicional();
        },

        mostrarInformacionAdicional() {
            this.dialogInformacionAdicional = true;
        },

        cancelarInformacionAdicional() {
            this.dialogInformacionAdicional = false;
        },

        getReportePremiosByDate() {
            let me = this;
            axios
                .get(
                    "api/Tiempos/GetAllPremiosByDate?idSorteo=" +
                    this.editedItem.idSorteo +
                    "&fecha=" +
                    this.editedItem.fecha.toString() +
                    "&companyId=" +
                    this.strCia,
                )
                .then(function (response) {
                    me.items2 = response.data;
                    me.nombreSorteo = "Sorteo: " + response.data[0].sorteoNombre;
                    me.fecha = "Fecha: " + me.editedItem.fechaString;
                    me.numeroGanador = "# Ganador: " + response.data[0].numero;
                    me.validInfo = true;
                })
                .catch(function (error) {
                    console.log(error);
                });
        },

        getReportePremios() {
            let me = this;
            axios
                .get(
                    "api/Tiempos/GetReporteHistoricoPremios?fechaInicio=" +
                    this.dates[0].toString() +
                    "&fechaFin=" +
                    this.dates[1].toString() +
                    "&companyId=" +
                    this.strCia,
                )
                .then(function (response) {
                    me.items = response.data;
                    me.validInfo = true;
                })
                .catch(function (error) {
                    console.log(error);
                });
        },

        closed() {
            this.customerModal = false;
        },
    },
};
</script>

<style scoped>
.reporte-container {
    padding-bottom: 60px;
}

/* Glassmorphism Styles */
.glass-card {
    background: rgba(255, 255, 255, 0.7) !important;
    backdrop-filter: blur(12px) !important;
    border: 1px solid rgba(255, 255, 255, 0.3) !important;
}

.theme--dark .glass-card {
    background: rgba(30, 30, 46, 0.8) !important;
    border: 1px solid rgba(255, 255, 255, 0.1) !important;
}

.glass-btn {
    background: rgba(25, 118, 210, 0.1) !important;
}

/* Table Styling */
.premium-table {
    background: transparent !important;
}

.premium-table >>> th {
    background: rgba(0, 0, 0, 0.03) !important;
    font-weight: 800 !important;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    font-size: 0.7rem !important;
}

.theme--dark .premium-table >>> th {
    background: rgba(255, 255, 255, 0.05) !important;
}

.premium-table >>> tr:hover {
    background: rgba(25, 118, 210, 0.05) !important;
}

/* Animations */
.animate-fade-in {
    animation: fadeIn 0.4s ease-out;
}

@keyframes fadeIn {
    from { opacity: 0; transform: translateY(10px); }
    to { opacity: 1; transform: translateY(0); }
}

.border-top {
    border-top: 1px solid rgba(0,0,0,0.05);
}

.theme--dark .border-top {
    border-top: 1px solid rgba(255,255,255,0.05);
}
</style>